import { useLayoutEffect, useState } from 'react';

import { TabsEnum, type ShellState } from '../AIShellContext';
import { CIQ_SHELL_EVENTS } from '../shellEvents';

const CLOSED: ShellState = { isOpen: false, tab: TabsEnum.CHAT, busy: false };

export const toggleShellTab = (tab: TabsEnum) => {
  window.dispatchEvent(new CustomEvent(CIQ_SHELL_EVENTS.TOGGLE_SHELL_TAB, { detail: { tab } }));
};

export const useShellState = (): ShellState => {
  const [state, setState] = useState<ShellState>(CLOSED);

  useLayoutEffect(() => {
    const handleState = (event: Event) => {
      const detail = (event as CustomEvent<ShellState>).detail;
      if (detail) {
        setState(detail);
      }
    };
    window.addEventListener(CIQ_SHELL_EVENTS.SHELL_STATE, handleState);
    window.dispatchEvent(new CustomEvent(CIQ_SHELL_EVENTS.REQUEST_SHELL_STATE));
    return () => window.removeEventListener(CIQ_SHELL_EVENTS.SHELL_STATE, handleState);
  }, []);

  return state;
};
